import { render, staticRenderFns } from "./EstimateApprovalMaster.vue?vue&type=template&id=4b603130&scoped=true&"
import script from "./EstimateApprovalMaster.vue?vue&type=script&lang=js&"
export * from "./EstimateApprovalMaster.vue?vue&type=script&lang=js&"
import style0 from "./EstimateApprovalMaster.vue?vue&type=style&index=0&id=4b603130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b603130",
  null
  
)

export default component.exports